import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PortalService } from '@vsolv/packages/portal-config/web';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './terms-of-service.page.html',
  standalone: false,
})
export class TermsOfServicePage {
  constructor(private portalSvc: PortalService) {}

  contactEmail = this.portalSvc.config.contactEmail;
  contactPhone = this.portalSvc.config.contactPhone;
}
